export default "__VITE_ASSET__HBmpI91u__"